module.exports = __webpack_public_path__ + "static/icons/icon-caret-right-fec82637a4ad44e2ae6b625d8c16cdc9.svg";